import { render, staticRenderFns } from "./ResultQuestionC.vue?vue&type=template&id=d724b370&"
import script from "./ResultQuestionC.vue?vue&type=script&lang=js&"
export * from "./ResultQuestionC.vue?vue&type=script&lang=js&"
import style0 from "./ResultQuestionC.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VApp,VBtn})
